import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderTextField from "../inputs/renderTextField";
import PersonFormValidation from "../validation/forms/personFormValidator";
import Button from '@material-ui/core/Button';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from '@material-ui/core/MenuItem';
import FormSelectItemValidation from "../validation/forms/formSelectItemValidation";

const CategoryForm =  (props) =>{
  const {submitCategory, handleSubmit, pillars, handleCancel} = props;
  return (
    <form onSubmit={handleSubmit(submitCategory)}>
      <div className={'form-group'}>
        <Field name="name" label={'Name'} component={RenderTextField} type="text" required fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field  min={"0"} step={"0.1"} name="weightOld" label={'Εξάμηνη βαρύτητα'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field  min={"0"} step={"0.1"} name="weightNew" label={'Βαρύτητα νέων καταστημάτων'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field  min={"0"} step={"0.1"} name="weightNewComing" label={'Βαρύτητα υφιστάμενων καταστημάτων'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field
          validate={FormSelectItemValidation}
          name="pillarId"
          label={'Pylon'}
          component={RenderSelectField}
          required
          fullWidth
        >
          {
            pillars.map(pillar => (
              <MenuItem value={pillar.id} key={pillar.id}>{pillar.name}</MenuItem>
            ))
          }
        </Field>
      </div>
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {props.category.id?'Edit':'Create'}
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary">
          {'Cancel'}
        </Button>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'category',
  validate: PersonFormValidation,
})(CategoryForm);



// WEBPACK FOOTER //
// ./src/components/category/categoryForm.js